import {
  createRouter,
  createWebHistory,
  RouteLocationNormalized
} from 'vue-router'

import { useToken } from '@/modules/auth'
import { useCachedUser } from '@/modules/user'

import { routes } from './routes/index'

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { left: 0, top: 0 }
  }
})

const defineMetaTitle = (to: RouteLocationNormalized) => {
  if (!to.meta?.skipTitleUpdate) {
    const nearestWithTitle = to.matched
      .slice()
      .reverse()
      .find(r => r.meta && r.meta.title)
    document.title = nearestWithTitle
      ? String(nearestWithTitle.meta.title)
      : 'Alice EHR'
  }
}

export const redirectToLogin = (to: RouteLocationNormalized) => {
  if (to.query?.email_to_sign || to.fullPath === '/login') {
    return false
  }
  const { hasToken } = useToken()
  const { getUser } = useCachedUser()
  const token = hasToken()
  const user = getUser()
  if (!token || !user) {
    return true
  }
  return false
}

router.beforeEach((to, _from, next) => {
  defineMetaTitle(to)
  const goToLoginPage = redirectToLogin(to)

  if (goToLoginPage) {
    next('/login')
  } else {
    next()
  }
})

export default router
